import {
  Button,
  ButtonGroup,
  Code,
  HStack,
  Link,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import ArrowBackSharpIcon from '@gamma/ui/icons/ArrowBackSharpIcon';
import { Board, Column, Panel } from '@gamma/ui/layout';
import { Modal } from '@gamma/ui/overlay';
import { i18n } from '@investigator/shared/localization';
import { formatJSONPreserveOrder } from '@investigator/shared/utils/formatJSON';

const { logscaleDetails } = i18n.pages.detections;

export interface LogscaleDetailsModalProps {
  alertsName: string;
  alertsTimestamp: string;
  isModalOpen: boolean;
  onModalClose: () => void;
  onOpen?: () => void;
  data: Record<string, string>;
  title: string;
  showBackToLogFlag?: boolean;
}

export const LogscaleDetailsModal = ({
  alertsName,
  alertsTimestamp,
  isModalOpen,
  onModalClose,
  onOpen,
  data: dataRaw,
  title,
  showBackToLogFlag,
}: LogscaleDetailsModalProps) => {
  const data = formatJSONPreserveOrder(dataRaw?.['@rawstring']);
  const mapData: string[][] = [];
  data?.forEach((value: string, key: string) => {
    mapData.push([key, value]);
  });

  return (
    <Modal
      size="xl"
      isOpen={isModalOpen}
      onClose={onModalClose}
      title={`${alertsName} | ${alertsTimestamp}`}
      body={
        <Board padding={3} gap={2} flexDirection="column">
          {showBackToLogFlag && (
            <Column display="flex" alignItems="center" gap={2} p={0}>
              <Button
                variant="ghost"
                size="xs"
                px={0}
                onClick={() => {
                  onModalClose();
                  onOpen && onOpen();
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
              <Link
                color="text.link"
                data-testid="connection-see-more-button"
                onClick={() => {
                  onModalClose();
                  onOpen && onOpen();
                }}
              >
                {logscaleDetails.backToLog}
              </Link>
            </Column>
          )}
          <Text>
            {title} Raw String | {alertsTimestamp}
          </Text>
          <Panel layerStyle="primary" padding={0}>
            <Code bg="layer.0" overflow="scroll" padding={3} width="inherit">
              <UnorderedList styleType="none" margin={0}>
                <Text>{'{'}</Text>
                {data &&
                  mapData.map(([key, value]) => (
                    <HStack key={key} alignItems="baseline" pl={3}>
                      <Text color="blue.300">{key}: </Text>
                      <Text color="green.300">{value}</Text>
                    </HStack>
                  ))}
                <Text>{'}'}</Text>
              </UnorderedList>
            </Code>
          </Panel>
        </Board>
      }
      footer={
        <ButtonGroup>
          <Button variant="solid" colorScheme="gray" onClick={onModalClose}>
            {logscaleDetails.close}
          </Button>
        </ButtonGroup>
      }
    />
  );
};
